var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.44,
    height: 17.28,
    viewBox: "0 0 10.13 13.04"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0v5.29l2.71-2.71 1.42 1.41-5.07 5.06L4.01 8H4v-.01l-4-4 1.41-1.41L4 5.16V0h2z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMy40NCIgaGVpZ2h0PSIxNy4yOCIgdmlld0JveD0iMCAwIDEwLjEzIDEzLjA0IiBmaWxsPSIjMDA2ZWFkIj4KICAgIDxwYXRoIGQ9Ik02IDB2NS4yOWwyLjcxLTIuNzEgMS40MiAxLjQxLTUuMDcgNS4wNkw0LjAxIDhINHYtLjAxbC00LTQgMS40MS0xLjQxTDQgNS4xNlYwaDJ6IiBmaWxsPSIjMDA2ZWFkIiAvPgo8L3N2Zz4K";
export { SvgDownloadArrow as ReactComponent };